// 9fbef606107a605d69c0edbcd8029e5d
import { css } from 'styled-components';

const styles = css`
  div.TCPModal__InnerContent {
    overflow: hidden;
    @media ${(props) => props.theme.mediaQuery.medium} {
      max-width: 458px;
      min-height: 237px;
      bottom: auto;
      padding: 19.5px;
    }
    @media ${(props) => props.theme.mediaQuery.large} {
      max-width: 580px;
      min-height: 300px;
    }
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      top: 100%;
      padding: 0px;
      border-radius: ${(props) => props.theme.spacing.ELEM_SPACING.XS_6};
    }
  }

  .alignTop {
    top: 8px;
    right: 16px;
  }
  .modal-content {
    display: flex;
    padding: 14px;
    margin-top: ${(props) => props.theme.spacing.ELEM_SPACING.LRG_2};
    @media ${(props) => props.theme.mediaQuery.medium} {
      margin-top: 33.5px;
      padding: 0;
    }
    @media ${(props) => props.theme.mediaQuery.large} {
      padding: ${(props) => props.theme.spacing.ELEM_SPACING.XL};
      margin-top: 3px;
    }
    flex-direction: column;
  }

  .title-content {
    display: flex;
    border: 1px solid ${(props) => props.theme.colors.BORDER_WARNING_YELLOW};
    border-radius: ${(props) => props.theme.spacing.ELEM_SPACING.XS_6};
    padding: ${(props) => props.theme.spacing.ELEM_SPACING.LRG};
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      padding: ${(props) => props.theme.spacing.ELEM_SPACING.MED};
    }
  }

  .bag-checkout-confirmation-text {
    text-align: center;
  }
  .button-container {
    display: flex;
    margin-top: ${(props) => props.theme.spacing.ELEM_SPACING.LRG};
    @media ${(props) => props.theme.mediaQuery.smallOnly} {
      flex-direction: column;
      margin-top: 39px;
    }
    @media ${(props) => props.theme.mediaQuery.mediumOnly} {
      margin-top: 41px;
    }
  }
  .confirmation-button {
    display: flex;
    justify-content: center;
    align-items: center;
    flex: 1;
    height: 51px;
    border: 1px solid ${(props) => props.theme.colorPalette.blue[900]};
    background-color: ${(props) => props.theme.colorPalette.white};
    &:hover {
      background: ${(props) => props.theme.colorPalette.white};
    }
  }
  .confirm-checkout {
    margin-left: 0;
    margin-top: 21px;
    @media ${(props) => props.theme.mediaQuery.medium} {
      margin-left: 19px;
      margin-top: 0;
    }
    @media ${(props) => props.theme.mediaQuery.large} {
      margin-left: 30px;
      flex: 1.5;
    }
    background-color: ${(props) => props.theme.colorPalette.blue[900]};
    &:hover {
      background: ${(props) => props.theme.colorPalette.blue[900]};
    }
  }
  .notification__image {
    height: ${(props) => props.theme.spacing.ELEM_SPACING.MED};
    margin-top: ${(props) => props.theme.spacing.ELEM_SPACING.XXXS};
  }
`;

export default styles;
